<div class="flex--column">
  <div class="content">
    <div class="flex flex--row full-width flex--justify-space-between flex--align-center header">
      <span class="calculated-on">
        <span class="text--bold">{{ 'shared.diseaseTable.calculatedOn' | translate }}</span>
        @if (lastCalculatedOn()) {
          <span class="text--gray" data-test="last-calculated-on">{{
            lastCalculatedOn() | date: 'short' : undefined : locale
          }}</span>
        } @else {
          <span class="text--gray" data-test="last-calculated-on">{{
            'shared.diseaseTable.notYetCalculated' | translate
          }}</span>
        }
      </span>
      <div class="flex--row flex--align-center table-toolbar-button-group">
        <app-recalculate-button
          (recalculate)="onRecalculate()"
          [disabled]="isRecalculationDisabled()"
          [disabledTooltip]="isCropYearReadOnly() ? ('UI.CurrentYearOnlyMutationMessage' | translate) : ''"
          [isLoading]="store.isDownyMildewCropFieldsSyncing()"
          [label]="'downyMildew.shared.recalculateAdviceAll' | translate"
        />
      </div>
    </div>

    <app-downy-mildew-action-menu #actionMenu [advices]="selectedAdvices()" context="overview" />

    <app-disease-overview-table
      (adviceTitleClick)="onCropFieldClick($event)"
      (actionMenuOpened)="onActionMenuOpened()"
      (cropFieldVisibilityChanged)="onCropFieldVisibilityChanged($event)"
      (selectedCropFieldsChanged)="onSelectedCropFieldsChange($event)"
      (selectedDatesChanges)="onSelectedDatesChange($event)"
      (sortMethodChanged)="onSortMethodChanged($event)"
      [actionMenu]="actionMenu.menu"
      [advices]="advices()"
      [availableSortMethods]="[SortMethodType.Name, SortMethodType.Advice, SortMethodType.Spray]"
      [diseaseCropFields]="diseaseCropFields()"
      [minimalDate]="this.store.downyMildewMinAdviceDate()"
      [cropYear]="store.cropYear()"
      [selectedDates]="selectedDates()"
    />
  </div>
  <div class="flex--row full-width flex--justify-end">
    <app-spray-legend />
  </div>
</div>
